import { render, staticRenderFns } from "./RegisterEventConfirm.vue?vue&type=template&id=3237ef38&"
import script from "./RegisterEventConfirm.vue?vue&type=script&lang=js&"
export * from "./RegisterEventConfirm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports